// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_auth_auth_module_ts":"07d680b2b42736ff","src_app_components_main_main_module_ts":"200c16c102a855f4"}[chunkId] + ".js";
};